import { colorMap } from '@data/general';
import { Box } from '@mui/material';

type ColorOption = keyof typeof colorMap;

interface LoadingDotsVariantProps {
    size?: number;
    color?: ColorOption;
    duration?: number;
    dots?: number;
}

const LoadingDotsVariant = ({
    color = 'surface',
    size = 8,
    duration = 1.5,
    dots = 3,
}: LoadingDotsVariantProps) => {
    // Generate the dots
    const renderDots = () => {
        const dotsArray = [];

        for (let i = 0; i < dots; i++) {
            dotsArray.push(
                <Box
                    key={i}
                    component="span"
                    sx={{
                        display: 'inline-block',
                        width: size,
                        height: size,
                        margin: size / 2 / 8,
                        borderRadius: '50%',
                        backgroundColor: colorMap[color],
                        animation: `dotPulse ${duration}s infinite ease-in-out`,
                        animationDelay: `${i * (duration / dots)}s`,
                        '@keyframes dotPulse': {
                            '0%, 100%': {
                                transform: 'scale(0.25)',
                                opacity: 0.5,
                            },
                            '50%': {
                                transform: 'scale(1)',
                                opacity: 1,
                            },
                        },
                    }}
                />,
            );
        }

        return dotsArray;
    };

    return (
        <Box
            className="loading-dots"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: size * 2,
            }}
        >
            {renderDots()}
        </Box>
    );
};

export default LoadingDotsVariant;
